import type { HomeContent } from '../content';

export default function QualityPolicy({ t }: { t: HomeContent['policy'] }) {
  return (
    <section id="qualidade" className="quality-policy" aria-labelledby="quality-policy-heading">
      <div className="policy-intro">
        <div className="policy-heading">
          <span className="policy-eyebrow">{t.eyebrow}</span>
          <h2 id="quality-policy-heading">{t.title[0]} <br />{t.title[1]}</h2>
          <div className="policy-rule" />
          <p className="policy-version">{t.version}<br /><time dateTime="2024-01-15">{t.date}</time></p>
        </div>
        <div className="policy-copy">
          <p className="policy-lead">{t.lead[0]}<strong>Zschimmer &amp; Schwarz do Brasil Ltda</strong>{t.lead[1]}</p>
          <p>{t.body}</p>
        </div>
      </div>
      <ol className="policy-commitments">
        {t.commitments.map((item, index) => (
          <li key={item.heading}>
            <span className="commitment-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <div><h3>{item.heading}</h3><p>{item.text}</p></div>
          </li>
        ))}
      </ol>
      <div className="policy-closing">
        <p>{t.closing}</p>
        <div className="policy-signature"><p><strong>{t.signatureNames}</strong></p><span>{t.signatureRole}</span></div>
      </div>
    </section>
  );
}
